import React, {useEffect, useState} from 'react';
import 'styles/company-profile.scss';
import InputContainer from 'components/InputContainer';

import validators from 'validator';
import {ContentLanguages, normalizePageFolderLanguages, getDefaultPageFolderLanguages, withExtraPageFolderLanguages, updateActivePageFolderLanguages, PageTypes} from 'enums';

import {changeState, updateFolder} from 'actions/folderActions';
import {useDispatch, useSelector} from 'react-redux';
import {makeSelectCreate} from 'reducers/selectors/folderSelector';
import CustomSelect from 'components/CustomSelect';
import messages from '../messages';

const AddPage = ({onCancel, selected}) => {
  const dispatch = useDispatch();
  const createState = useSelector(makeSelectCreate());
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [allLangages, setAllLanguages] = useState([]);

  const handleChange = (key, value) => {
    const newPage = {...page};
    newPage[key] = value;
    setPage(newPage);
  };

  const [page, setPage] = useState({
    title: '',
    subDomain: '',
    pageType: PageTypes.Project,
    languages: [],
    description: '',
  });

  const [pageError, setPageError] = useState(null);

  const validations = {
    title: {
      validate: (value) => validators.isLength(value, {min: 4, max: 50}),
      error: `${messages.enterValid} name`,
    },
    subDomain: {
      validate: (value) => validators.isLength(value, {min: 4, max: 50}),
      error: `${messages.enterValid} subdomain`,
    },
  };

  const [validationErrors, setValidationErrors] = useState({
    title: {
      isValid: false,
    },
    subDomain: {
      isValid: false,
    },
  });

  const validateField = (key, value) => {
    const validationForKey = validations[key];
    const newValidationErrors = {...validationErrors};

    if (!validationForKey.validate(value)) {
      newValidationErrors[key] = {
        isValid: false,
        error: validationForKey.error,
      };
      setValidationErrors(newValidationErrors);
    } else if (!validationErrors[key].isValid) {
      newValidationErrors[key] = {isValid: true};
      setValidationErrors(newValidationErrors);
    }
  };

  const checkForValidation = () => {
    let valid = true;
    const moved = false;
    const newValidationErrors = {...validationErrors};

    Object.keys(page).forEach((key) => {
      const validationForKey = validations[key];
      const value = page[key] ? page[key].toString() : '';

      if (validationForKey) {
        if (!validationForKey.validate(value)) {
          valid = false;

          newValidationErrors[key] = {
            isValid: false,
            error: validationForKey.error,
          };
        } else {
          newValidationErrors[key] = {
            isValid: true,
            error: '',
          };
        }
      }
      setValidationErrors(newValidationErrors);
    });

    return valid;
  };

  const onCreatePage = async (event) => {
    if (event !== undefined && event.preventDefault) {
      event.preventDefault();
    }

    const isValid = checkForValidation();
    if (!isValid) return;

    dispatch(updateFolder(selected._id, page));
  };

  useEffect(() => {
    if (createState.createSuccess) {
      dispatch(changeState());
      onCancel();
    } else if (createState.createFailed) {
      // setPageError(createState.createError);
    }
  }, [createState]);

  const getLanguages = (type) => {
    const list = Object.values(ContentLanguages).map((language) => ({
      name: language.name,
      code: language.code,
      value: language.code,
    }));

    setAllLanguages(list);

    const currentLanguages = normalizePageFolderLanguages(selected.languages);
    const languages = withExtraPageFolderLanguages(
      currentLanguages.length ? currentLanguages : getDefaultPageFolderLanguages()
    );

    const newPage = !page.subDomain ? {...selected} : {...page};
    newPage.languages = languages;
    newPage.pageType = type;
    setPage(newPage);

    setSelectedLanguages(languages.filter((language) => language.isActive).map((lan) => lan.code));
  };

  useEffect(() => {
    getLanguages(selected.pageType);
  }, [selected]);
  return (
    <div className="profile-edit bg-white  pl-0 py-4 pr-4">
      <div className="h-flex w-100 detail-edit-section m-0 pl-0">
        <h3 className="mb-3">{messages.editPage}</h3>

        <CustomSelect
          className="bg mb-2 select-domain-name"
          options={Object.values(PageTypes).map((type) => ({
            value: type,
            label: type,
          }))}
          value={page.pageType}
          placeholder={messages.pageTypePlaceholder}
          onChange={(event) => {
            getLanguages(event);
          }}
          getOptionLabel={(e) => e.label}
        />
        <InputContainer
          type="text"
          value={page.title}
          placeholder={messages.pageNamePlaceholder}
          handleChange={(event) => handleChange('title', event.target.value)}
          validate={(val) => validateField('title', val)}
          validationError={validationErrors.title.error}
          inputClass="form-control"
        />
        <InputContainer
          type="text"
          className="mt-2"
          value={page.subDomain}
          placeholder={messages.subDomain}
          handleChange={(event) => {
            let value = event.target.value.toLowerCase();
            value = value.replace('.jidipi.com', '');
            handleChange('subDomain', value);
          }}
          validate={(val) => validateField('subDomain', val)}
          validationError={validationErrors.subDomain.error}
          inputClass="form-control"
        />

        <div className="mt-2">
          <CustomSelect
            className="bg select-domain-name"
            options={allLangages}
            value={selectedLanguages}
            isMulti
            onChange={(val) => {
              const languages = updateActivePageFolderLanguages(page.languages, val);
              setSelectedLanguages(languages.filter((language) => language.isActive).map((language) => language.code));
              const newPage = {...page};
              newPage.languages = languages;
              setPage(newPage);
            }}
            getOptionLabel={(e) => e.code}
            getOptionValue={(e) => e}
          />
        </div>
        {pageError && (
          <p className="form-error-message my-2 input-validation-error">
            {pageError}
          </p>
        )}
        <div className="mt-2">
          <button
            className="btn-red btn mr-2"
            disabled={createState.submitting}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            disabled={createState.submitting}
            className="btn-blue btn mr-2"
            onClick={onCreatePage}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPage;
